export const FINAL_REQUEST_STATUSES = Object.freeze(['completed', 'rejected', 'cancelled']);
export const STRICT_COMMENT_ACTIONS = Object.freeze(['reject', 'return', 'cancel']);
export const DEFAULT_CONFIGURABLE_COMMENT_ACTIONS = Object.freeze([
    'complete',
    'partially_complete',
    'accept',
    'accept_partially',
    'change_status',
    'other_final'
]);

const EXPLICIT_FINAL_ACTIONS = Object.freeze([
    'complete',
    'partially_complete',
    'accept',
    'accept_partially',
    'change_status'
]);

const DEFAULT_ACTION_TARGETS = Object.freeze({
    reject: 'rejected',
    complete: 'awaiting_acceptance',
    partially_complete: 'partially_completed',
    accept: 'completed',
    accept_partially: 'completed',
    cancel: 'cancelled'
});

export function getRequestWorkflowConfig(request) {
    const config = request && request.RequestType && request.RequestType.workflow_config;
    if (typeof config === 'string') {
        try {
            const parsed = JSON.parse(config);
            return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
        } catch (error) {
            return {};
        }
    }
    return config && typeof config === 'object' && !Array.isArray(config) ? config : {};
}

export function getClosingCommentConfig(request) {
    const workflow = getRequestWorkflowConfig(request);
    const config = workflow.closingComment || workflow.closing_comment || {};
    const requiredActionsSource = config.requiredActions || config.required_actions;
    return {
        required: config.required === true ||
        config.isRequired === true ||
        config.is_required === true ||
        workflow.closingCommentRequired === true ||
        workflow.closing_comment_required === true,
        requiredActions: Array.isArray(requiredActionsSource)
            ? requiredActionsSource.map(value => String(value || '').trim()).filter(Boolean)
            : null
    };
}

export function isClosingCommentRequired(request) {
    return getClosingCommentConfig(request).required;
}

export function resolveRequestActionTargetStatus(request, action) {
    const workflow = getRequestWorkflowConfig(request);
    const stateMachineConfig = workflow.stateMachineConfig || workflow.state_machine_config || {};
    const actionToStatus = stateMachineConfig.actionToStatus || stateMachineConfig.action_to_status || {};
    let targetStatus = actionToStatus[action] || DEFAULT_ACTION_TARGETS[action] || null;

    if (action === 'complete' && targetStatus === 'awaiting_acceptance' && workflow.requiresAcceptance === false) {
        targetStatus = 'completed';
    }

    return targetStatus;
}

export function actionClosesRequest(request, action) {
    return FINAL_REQUEST_STATUSES.indexOf(resolveRequestActionTargetStatus(request, action)) !== -1;
}

export function isRequestActionCommentRequired(request, action, targetStatus = null) {
    const normalizedAction = String(action || '').trim();
    if (STRICT_COMMENT_ACTIONS.indexOf(normalizedAction) !== -1) {
        return true;
    }

    const config = getClosingCommentConfig(request);
    if (!config.required) {
        return false;
    }

    const resolvedTargetStatus = targetStatus || resolveRequestActionTargetStatus(request, normalizedAction);
    if (Array.isArray(config.requiredActions)) {
        if (config.requiredActions.indexOf(normalizedAction) !== -1) {
            return normalizedAction !== 'change_status' || isFinalRequestStatus(resolvedTargetStatus);
        }
        const isOtherFinalAction = isFinalRequestStatus(resolvedTargetStatus) &&
            EXPLICIT_FINAL_ACTIONS.indexOf(normalizedAction) === -1;
        return isOtherFinalAction && config.requiredActions.indexOf('other_final') !== -1;
    }

    return actionClosesRequest(request, normalizedAction) ||
        normalizedAction === 'complete' ||
        normalizedAction === 'partially_complete';
}

export function isFinalRequestStatus(status) {
    return FINAL_REQUEST_STATUSES.indexOf(String(status || '').trim()) !== -1;
}
